var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M7,10.59,2.67,6,7,1.41,5.67,0,0,6l5.67,6Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }